import { MatxLayoutSettings } from "app/components/MatxLayout/settings";
import axios from "axios";
import { useEffect } from "react";
import { createContext, useState } from "react";

const NavigationItemsContext = createContext({
  updateSettings: () => {},
  settings: MatxLayoutSettings,
});

export const NavigationItemsProvider = ({ children }) => {
  const [navigationItems, setNavigationItems] = useState();
  const [activeNavigationItem, setActiveNavigationItem] = useState([]);
  const [navigationItemsRefreshDate, setNavigationItemsRefreshDate] = useState(
    new Date()
  );

  const refreshNavigationItems = () => {
    setNavigationItemsRefreshDate(new Date());
  };
  useEffect(() => {
    axios.get("/api/navigation").then((response) => {
      setNavigationItems(response.data);
    });
  }, [navigationItemsRefreshDate]);

  return (
    <NavigationItemsContext.Provider
      value={{
        activeNavigationItem,
        setActiveNavigationItem,
        navigationItems,
        setNavigationItems,
        refreshNavigationItems,
      }}
    >
      {children}
    </NavigationItemsContext.Provider>
  );
};

export default NavigationItemsContext;
